import { defineStore } from 'pinia'
import { ref, computed, readonly } from 'vue'

export const useAppStore = defineStore('app', () => {
  // 状态
  const collapsed = ref(false)
  const theme = ref<'light' | 'dark'>('light')
  const locale = ref('zh-CN')
  const loading = ref(false)
  const priceDisplayMode = ref<'numeric' | 'currencyStr'>('currencyStr')
  const breadcrumbs = ref<Array<{ title: string; path?: string }>>([])

  // 计算属性
  const isDark = computed(() => theme.value === 'dark')
  const sidebarWidth = computed(() => collapsed.value ? 80 : 256)

  // 操作方法
  const toggleSidebar = () => {
    collapsed.value = !collapsed.value
    console.log('[CT_SIDEBAR] 侧边栏状态切换:', collapsed.value ? '收起' : '展开')
  }

  const setTheme = (newTheme: 'light' | 'dark') => {
    theme.value = newTheme
    document.documentElement.setAttribute('data-theme', newTheme)
    console.log('[CT_THEME] 主题切换为:', newTheme)
  }

  const setLoading = (status: boolean) => {
    loading.value = status
    if (status) {
      console.log('[CT_LOADING] 全局加载状态: 开启')
    } else {
      console.log('[CT_LOADING] 全局加载状态: 关闭')
    }
  }

  const setLanguage = (newLocale: string) => {
    locale.value = newLocale
    localStorage.setItem('control-tower-locale', newLocale)
    console.log('[CT_LOCALE] 语言切换为:', newLocale)
  }

  const setLocale = (newLocale: string) => {
    setLanguage(newLocale)
  }

  const setBreadcrumbs = (newBreadcrumbs: Array<{ title: string; path?: string }>) => {
    breadcrumbs.value = newBreadcrumbs
  }

  const setPriceDisplayMode = (mode: 'numeric' | 'currencyStr') => {
    priceDisplayMode.value = mode
    localStorage.setItem('ct_price_display_mode', mode)
    console.log('[CT_PRICE] 价格显示模式切换为:', mode)
  }

  const togglePriceDisplayMode = () => {
    setPriceDisplayMode(priceDisplayMode.value === 'numeric' ? 'currencyStr' : 'numeric')
  }

  const toggleTheme = () => {
    setTheme(theme.value === 'light' ? 'dark' : 'light')
  }

  // 初始化方法
  const initApp = () => {
    // 从本地存储恢复语言设置
    const savedLocale = localStorage.getItem('ct_locale')
    if (savedLocale) {
      locale.value = savedLocale
    }

    const savedPriceMode = localStorage.getItem('ct_price_display_mode') as 'numeric' | 'currencyStr'
    if (savedPriceMode) {
      priceDisplayMode.value = savedPriceMode
    }

    console.log('[CT_APP_STORE] 应用状态初始化完成')
  }

  return {
    // 状态
    collapsed: readonly(collapsed),
    theme: readonly(theme),
    locale: readonly(locale),
    loading: readonly(loading),
    priceDisplayMode: readonly(priceDisplayMode),
    breadcrumbs: readonly(breadcrumbs),

    // 计算属性
    isDark,
    sidebarWidth,

    // 操作方法
    toggleSidebar,
    setTheme,
    setLoading,
    setLanguage,
    setLocale,
    setBreadcrumbs,
    setPriceDisplayMode,
    togglePriceDisplayMode,
    toggleTheme,
    initApp
  }
})
